import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../../service/backtest.service";
import $ from "jquery";
import ButtonGroup from "../buttonGroup";
import TreeHelper from "./TreeHelper.js";
import Pannel from "../../Create/universe/customTreeTable/pannel";
import Spinner from "../../../common/spinner";
import "./TreeTable.style.scss";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

class TreeTable extends Component {
  state = {
    modifiedData: [],
    resetOnChangeInput: false,
    checkBoxSelectedList: [],

    showSearchField: false,
    pannelSearchValue: "",
    autoCompleteData: [],
    ajax_in_progress: false,
    displayAutoCompleteOp: true,
    pannel_fund_name: "",
    pannel_asset_class: "",
    pannel_classification: "",
    pannel_symbol: "",
    pannel_style: "",
    pannelAllocationValue: null,
    showPannelData: false,
  };
  componentDidMount() {
    // jquery function goes here
    $("#mytable").on("click", ".toggle", function () {
      //Gets all <tr>'s  of greater depth
      //below element in the table
      var findChildren = function (tr) {
        var depth = tr.data("depth");
        return tr.nextUntil(
          $("tr").filter(function () {
            return $(this).data("depth") <= depth;
          })
        );
      };

      var el = $(this);
      var tr = el.closest("tr"); //Get <tr> parent of toggle button
      var children = findChildren(tr);

      //Remove already collapsed nodes from children so that we don't
      //make them visible.
      //(Confused? Remove this code and close Item 2, close Item 1
      //then open Item 1 again, then you will understand)
      var subnodes = children.filter(".expand");
      subnodes.each(function () {
        var subnode = $(this);
        var subnodeChildren = findChildren(subnode);
        children = children.not(subnodeChildren);
      });

      //Change icon and hide/show children
      if (tr.hasClass("collapse-table")) {
        tr.removeClass("collapse-table").addClass("expand");
        children.hide();
        el.removeClass("fa-minus-square").addClass("fa-plus-square");
      } else {
        tr.removeClass("expand").addClass("collapse-table");
        children.show();
        el.removeClass("fa-plus-square").addClass("fa-minus-square");
      }
      return children;
    });
    // collapsing only cash row
    setTimeout(
      () => ($("#CASH").length > 0 ? $("#CASH .toggle").click() : null),
      0
    );

    const { data } = this.props;
    if (data && data.length > 0) {
      let modifiedData = TreeHelper.DataModify(data);
      this.setState({
        modifiedData,
      });

      //100% validation
      // this.validation(myUniverse);
    }
  }
  componentWillReceiveProps(nextProps) {
    console.log(nextProps, "---component will receive props-------------");
    const { data } = nextProps;
    if (data && data.length > 0) {
      let modifiedData = TreeHelper.DataModify(data);
      this.setState({
        modifiedData,
      });

      //100% validation
      // this.validation(myUniverse);
    }
  }

  validation = (data) => {
    const { allocationSumError } = this.props;
    let sum = data.map((e, i) => e["val"]).reduce((a, b) => a + b * 1, 0);

    if (sum === 100) {
      // valid data
      allocationSumError(false);
    } else {
      // not valid data
      allocationSumError(true);
    }
  };
  innerContent = (data) => {
    let name = Object.keys(data)[0];
    let innerList = Object.keys(data[name]);

    const inputFieldHandler = (e) => {
      const { inputFieldHandlerRedux } = this.props;
      let index = e.target.getAttribute("index") * 1;
      let { value } = e.target;
      inputFieldHandlerRedux(index, "val", value);

      this.setState({ resetOnChangeInput: true });
      setTimeout(() => this.setState({ resetOnChangeInput: false }), 400);
      // setTimeout(() => this.validation(myUniverse), 100);
    };

    const checkBoxHandler = (e) => {
      let index = e.target.getAttribute("index") * 1;
      let status = e.target.checked;

      if (status) {
        this.setState({
          checkBoxSelectedList: [...this.state.checkBoxSelectedList, index],
        });
      } else {
        this.setState({
          checkBoxSelectedList: this.state.checkBoxSelectedList.filter(
            (item) => item !== index
          ),
        });
      }
    };
    const coreAllocationCounter = (type, name, type2, name2) => {
      let { data } = this.props;
      let Data;

      if (type2 && name2) {
        Data = data.filter((e) => e[type2] == name2);
      } else {
        Data = data;
      }

      let value = Data.filter((e) => e[type] == name).map((el) =>
        el.val == null ? 0 : el.val * 1
      );

      let reduced_val = value.length > 0 ? value.reduce((a, b) => a + b) : 0;

      return reduced_val == 0 ? "" : reduced_val;
    };

    return (
      <Fragment key={`${name}`}>
        <tr
          data-depth="0"
          className="collapse-table level0"
          style={{ height: "2px" }}
        >
          <td className="td-depth-0" id={name.toUpperCase()}>
            <i className="toggle fa fa-minus-square" aria-hidden="true"></i>
            {name}
          </td>
          <td>&nbsp;</td>
          <td>
            <input
              type="text"
              value={coreAllocationCounter("asset_class", name)}
              disabled
              className="ip-field"
              style={{ backgroundColor: "#eee" }}
            />
          </td>
        </tr>
        {innerList.map((element, i) => (
          <Fragment key={`${element}-${i}`}>
            <tr data-depth={1} className="collapse-table level1">
              <td className="td-depth-1">
                <i
                  className="cursor toggle fa fa-minus-square"
                  aria-hidden="true"
                ></i>
                {element}
              </td>
              <td>&nbsp;</td>
              <td>
                <input
                  type="text"
                  value={coreAllocationCounter("classification", element)}
                  disabled
                  className="ip-field"
                  style={{ backgroundColor: "#eee" }}
                />
              </td>
            </tr>
            {data[name][element].map((d, i) => (
              <Fragment key={`${Object.keys(d)[0]}-${i}`}>
                <tr data-depth={2} className={`collapse-table level${2}`}>
                  <td className="td-depth-2">
                    <i
                      className="cursor toggle fa fa-minus-square"
                      aria-hidden="true"
                    ></i>
                    {Object.keys(d)[0]}
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <input
                      type="text"
                      value={coreAllocationCounter(
                        "style",
                        Object.keys(d)[0],
                        "classification",
                        element
                      )}
                      disabled
                      className="ip-field"
                      style={{ backgroundColor: "#eee" }}
                    />
                  </td>
                </tr>

                {d[Object.keys(d)[0]].map(function (dl) {
                  return (
                    <tr
                      data-depth={3}
                      className={`collapse-table level${3}`}
                      key={`${dl.fund_name}-${dl.index}`}
                      id={`${dl.fund_name.replace(regex, "")}`}
                    >
                      <td className="td-depth-3" id={`row-${dl.index}`}>
                        <input
                          type="checkbox"
                          index={dl.index}
                          className="cursor"
                          style={{ marginRight: "10px" }}
                          onChange={(e) => checkBoxHandler(e)}
                        />
                        {dl.fund_name}
                      </td>
                      <td>{dl.symbol}</td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          // max={maxUpperBound}
                          defaultValue={dl.val}
                          index={dl.index}
                          onChange={(e) => inputFieldHandler(e)}
                          className="ip-field"
                        />
                      </td>
                    </tr>
                  );
                })}
              </Fragment>
            ))}
          </Fragment>
        ))}
      </Fragment>
    );
  };

  //========== pannel ===========
  addButtonHandler = () => {
    const { showSearchField } = this.state;

    this.setState({
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: null,
      showSearchField: !showSearchField,
    });
  };

  addSecurity = () => {
    const {
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      pannelAllocationValue,
    } = this.state;
    let obj = {
      asset_class: pannel_asset_class,
      fund_name: pannel_fund_name,
      classification: pannel_classification,
      fund_type: "",
      style: pannel_style,
      symbol: pannel_symbol,
      val: pannelAllocationValue,
    };

    console.log(obj, "------------obj------------");
    this.props.addSymbol(obj);

    // resetting table

    this.setState({ resetOnChangeInput: true });
    setTimeout(() => this.setState({ resetOnChangeInput: false }), 400);
    //----------------
    setTimeout(function () {
      let element = document.getElementById("add_security");
      if (element) {
        element.innerHTML = `ADDED <i class="fa fa-check" aria-hidden="true" ></i>`;
      }
    }, 100);

    setTimeout(() => {
      this.setState({
        showSearchField: false,
        showPannelData: false,
      });
      let element = document.getElementById(
        `${obj["fund_name"].replace(regex, "")}`
      );
      if (element) {
        element.scrollIntoView({ block: "center" });
      }
    }, 800);

    this.setState({
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: "",
      // showSearchField: false,
    });
  };
  cancelSecurity = () => {
    this.setState({
      pannelSearchValue: "",
      pannel_fund_name: "",
      pannel_asset_class: "",
      pannel_classification: "",
      pannel_symbol: "",
      pannel_style: "",
      pannelAllocationValue: "",
      showSearchField: false,
      showPannelData: false,
    });
  };

  pannelSearchHandler = (e) => {
    let value = e.target.value.toUpperCase();
    this.setState({ pannelSearchValue: value, displayAutoCompleteOp: true });
    this.getAutoCompleteData();
  };

  suggestionHandler = (e) => {
    const { autoCompleteData } = this.state;
    let index = e.target.getAttribute("index");
    let data = autoCompleteData[index];

    let pannel_fund_name = data["fund_name"];
    let pannel_asset_class = data["asset_class"];
    let pannel_classification = data["classification"];
    let pannel_symbol = data["symbol"];
    let pannel_style = data["style"];

    // clear list on selecting any option
    this.setState({
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      displayAutoCompleteOp: false,
      showPannelData: true,
    });
  };

  pannelAllocationHandler = (e) => {
    e.preventDefault();
    this.setState({
      pannelAllocationValue: e.target.value,
    });
  };

  getAutoCompleteData = () => {
    let { pannelSearchValue } = this.state;
    if (pannelSearchValue.length >= 3) {
      if (!this.state.ajax_in_progress) {
        this.setState({
          ajax_in_progress: true,
        });
        BacktestService.getAutocomplete(`${pannelSearchValue}`).then((res) => {
          this.setState({
            ajax_in_progress: false,
          });
          if (res) {
            this.setState({
              autoCompleteData: res,
            });
          }
        });
      }
    }
  };
  clearButtonHandler = () => {
    const { removeSymbols } = this.props;
    const { checkBoxSelectedList } = this.state;
    removeSymbols(checkBoxSelectedList);

    this.setState({
      checkBoxSelectedList: [],
    });
  };

  // saveHandler = () => {
  //   const { myUniverse } = this.props;

  //   window.localStorage.setItem("myUniverse", JSON.stringify(myUniverse));
  // };
  // ===========================
  render() {
    const {
      myUniverse,
      myUniverse_allocation_sumError,
      data,
      saveMessage,
      postingDatafailed,
      loading,
      spinner,
    } = this.props;
    const {
      modifiedData,
      resetOnChangeInput,
      pannelSearchValue,
      showSearchField,
      autoCompleteData,
      displayAutoCompleteOp,
      pannel_fund_name,
      pannel_asset_class,
      pannel_classification,
      pannel_symbol,
      pannel_style,
      pannelAllocationValue,
      showPannelData,
    } = this.state;

    const save_button_BlockCondition =
      myUniverse_allocation_sumError || (data.length === 0 ? true : false);

    return (
      <div className="myUniverse_table">
        <div
          style={{
            maxHeight: "50vh",
            overflowY: "auto",
            margin: "10px 0",
            transition: "all 6s ease 0s",
          }}
        >
          <table id="mytable">
            <thead>
              <tr>
                <th style={{ paddingLeft: "30px" }} className="sticky">
                  ASSET CLASS/CLASSIFICATION/STYLE/SECURITY
                </th>
                <th
                  style={{
                    width: "200px",
                  }}
                  className="sticky"
                >
                  SYMBOL
                </th>
                <th className="sticky">DEFAULT ALLOCATION(%)</th>
              </tr>
            </thead>
            {data.length > 0 ? (
              <tbody>
                {modifiedData.length ||
                (modifiedData.length && resetOnChangeInput)
                  ? modifiedData.map((element) => {
                      return this.innerContent(element);
                    })
                  : null}
              </tbody>
            ) : null}
          </table>
        </div>
        {loading && <Spinner size={"medium"} />}
        <Pannel
          pannelSearchValue={pannelSearchValue}
          showSearchField={showSearchField}
          autoCompleteData={autoCompleteData}
          pannel_fund_name={pannel_fund_name}
          pannel_asset_class={pannel_asset_class}
          pannel_classification={pannel_classification}
          pannel_symbol={pannel_symbol}
          pannel_style={pannel_style}
          displayAutoCompleteOp={displayAutoCompleteOp}
          // maxUpperBound={maxUpperBound}
          pannelAllocationValue={pannelAllocationValue}
          showPannelData={showPannelData}
          // // functions
          pannelSearchHandler={this.pannelSearchHandler}
          suggestionHandler={this.suggestionHandler}
          pannelAllocationHandler={this.pannelAllocationHandler}
          addSecurity={this.addSecurity}
          cancelSecurity={this.cancelSecurity}
        />
        <ButtonGroup
          blockSubmit={save_button_BlockCondition}
          addHandler={this.addButtonHandler}
          removeHandler={this.clearButtonHandler}
          saveHandler={() => this.props.saveButtonHandler()}
          saveMessage={saveMessage}
          postingDatafailed={postingDatafailed}
          spinner={spinner}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  allocationSumError: (payload) =>
    dispatch({
      type: "SET_IQCIO_LIVE_ALLOCATION_SUM_ERROR",
      payload,
    }),
  inputFieldHandlerRedux: (i, key, value) =>
    dispatch({
      type: "SET_IQCIO_LIVE_MYUNIVERSE_VALUE",
      payload: { i, key, value },
    }),
  addSymbol: (payload) =>
    dispatch({ type: "ADD_IQCIO_LIVE_MYUNIVERSE_obj", payload }),
  removeSymbols: (payload) =>
    dispatch({ type: "REMOVE_MY_UNIVERSE_DATA", payload }),
});
export default connect(
  ({ iqciolive: { myUniverse, myUniverse_allocation_sumError } }) => ({
    myUniverse,
    myUniverse_allocation_sumError,
  }),
  mapDispatchToProps
)(TreeTable);



// WEBPACK FOOTER //
// ./src/components/pages/MyUniverse/treeTable/TreeTable.jsx